export default function Option({ alphabet, selected }) {
  return <span className={`mr-3 rounded-lg ${selected ? "bg-sky-200" : "bg-gray-200"} px-3 py-2`}>{alphabet}</span>;
}
